import { callApi } from './api';
import { useMutation } from '@tanstack/react-query';

const authApiUrl = import.meta.env.VITE_API_URL_V1 + '/auth';

export const loginWithEmail = async ({ email, redirectTo }: { email: string; redirectTo?: string }) => {
    return callApi({
        url: `${authApiUrl}/login`,
        method: 'POST',
        data: { email, redirectTo },
    });
};
export const useLoginWithEmail = () => {
    return useMutation({ mutationFn: loginWithEmail });
};
